/**
 * checkbox
 */
export const MaMFormHandler = (function () {

    var getBaseUrl = function(){
        
        if($('#mam-base-url').length > 0){
            return $('#mam-base-url').val();
        }
        return '/about-me';
    }

    var init =  function () {   
        

        $(".check-buttons-multi.noembed .switchme").on('click', function(){
            
            var inputName = $(this).attr('data-attr-key');


            if($(this).find('.bsave[data-attr-key="'+inputName+'"]:checked').length > 0){
                $(this).find('.bsave[data-attr-key="'+inputName+'"]').trigger('blur');
            }else{
                $(this).find('.bsave[data-attr-key="'+inputName+'"]').trigger('blur');
            }

        });

        $("#mam-container .bsave").off('blur').on('blur', function(){
            
            var elem = $(this);
            var inputName = $(elem).attr('name');
            var inputValue = $(elem).val();
            var sectionUrl = $("#mam-container").attr('data-attr-section');

            var submitButton = $("#mam-container").find('#mam-save');

            var formData = new FormData();

            var componentHeader = $(elem).closest('.row').find('.cheader-label');
            
            if($(elem).hasClass('bsave-multi')){ 
                var key = $(this).attr('data-attr-key');
                $('input.bsave-multi[data-attr-key="'+key+'"]').each(function(){

                    if($(this).attr('type') == 'checkbox' && $(this).prop('checked') == false){
                        return;
                    }

                    if($(this).attr('type') == 'radio' && $(this).prop('checked') == false){
                        return;
                    }

                    formData.append($(this).attr('name'), $(this).val());
                    if($(this).val()){
                        $(this).addClass('noborder');
                    }else{
                        $(this).removeClass('noborder');
                    }
                });
            }else{

                if($(elem).attr('type') == 'checkbox'){
                    if($(elem).prop('checked')){
                        inputValue = 1;
                    }else{
                        inputValue = '';
                    }
                }

                formData.append(inputName, inputValue);

                if(inputValue){
                    $(elem).addClass('noborder');
                }else{
                    $(elem).removeClass('noborder');
                }
            }



            $(submitButton).html('Saving');

            $.ajax({
                type: "POST",
                url: window.location.href,
                data: formData,
                processData: false,
                contentType: false,
                dataType: "json",
                headers: {
                    "x-csrf-token":
                    '{"csrf_name":"' +
                    $("#csrf_name").val() +
                    '","csrf_value":"' +
                    $("#csrf_value").val() +
                    '"}',
                },
                success: function(res, textStatus, jqXHR) {
                    var result = JSON.parse(res.result);
                    
                   if(!result.success){
                        var message = result.message.split(': ');
                        var errorField = message[0];
                        var errorMessage = message[1]
            
                        $("#mam-container .input-errors").html("");
                        $("#mam-container .input-error-" + errorField).html(errorMessage);
                   }else{
                        $("#mam-container .input-errors").html("");
                        $(submitButton).removeClass('btn-primary').addClass('btn-success').html('Saved!');

                        setTimeout(() => {
                            $(submitButton).removeClass('btn-success').addClass('btn-primary').html('Save');
                        }, "3000");

                        //put a save message in the component itself
                        if($(componentHeader).find('.success-msg').length){
                            $(componentHeader).find('.success-msg').remove();                    
                        }
                                    
                        $(componentHeader).append('<span class="success-msg">Saved</span>');
                        
                        var componentSuccessMessage = $(componentHeader).find('.success-msg');
                        
                        setTimeout(() => {
                            $(componentSuccessMessage).fadeOut();
                        }, "3000");
                   }
                   return false;
                },
                error: function(res, textStatus, jqXHR) {
                    console.log(res);
                    return false;
                },
            });

            return false;

        });
        

        $("#mam-container").off('submit').on('submit', function(){

            var submitButton = $("#mam-container").find('#mam-save');

            var formData = new FormData($("#mam-container")[0]);

            $(submitButton).html('Saving');

            $.ajax({
                type: "POST",
                url: window.location.href,
                data: formData,
                processData: false,
                contentType: false,
                dataType: "json",
                headers: {
                    "x-csrf-token":
                    '{"csrf_name":"' +
                    $("#csrf_name").val() +
                    '","csrf_value":"' +
                    $("#csrf_value").val() +
                    '"}',
                },
                success: function(res, textStatus, jqXHR) {
                    var result = JSON.parse(res.result);
                    
                   if(!result.success){
                        var message = result.message.split(': ');
                        var errorField = message[0];
                        var errorMessage = message[1]
            
                        $("#mam-container .input-errors").html("");
                        $("#mam-container .input-error-" + errorField).html(errorMessage);
                   }else{
                        $("#mam-container .input-errors").html("");
                        $(submitButton).removeClass('btn-primary').addClass('btn-success').html('Saved!');

                        setTimeout(() => {
                            $(submitButton).removeClass('btn-success').addClass('btn-primary').html('Save');
                        }, "3000");
                   }
                   return false;
                },
                error: function(res, textStatus, jqXHR) {
                    console.log(res);
                    return false;
                },
            });

            return false;
        });
         
    }
  
    return {
      init: init,
      getBaseUrl: getBaseUrl
    }
  
  }());
  
  
  